import {c, h, M, m, v} from '@components/timeline-new/diagram/graph/svg'
import {
  ArrowFn,
  ArrowType,
  Interval,
  IntervalFn
} from '@components/timeline-new/diagram/graph/task-box-link/types'
import {
  centerToBottom,
  centerToTop
} from '@components/timeline-new/diagram/graph/task-box-link/utils'
import {rowHeight} from '@components/timeline-new/timeline-new-store'
import {cn} from '@containers/html-utils'

const roundness = 6

const topArrow = (x: number, y: number, dx: number, dy: number, ddx: number) =>
  cn(
    M(x, y),
    m(2, 0),
    h(4.5),
    c(roundness, -roundness, 0),
    v(-rowHeight + 2 * roundness + dy),
    c(roundness, -roundness, 1),
    h(dx + ddx - 21.5)
  )

const topIntervals = (
  x: number,
  y: number,
  dx: number,
  dy: number,
  ddx: number
): Interval[] => {
  const res: Interval[] = []
  x += 6.5 + roundness
  y += -roundness
  const ddy = -rowHeight + 2 * roundness + dy
  res.push({from: {x, y}, to: {x, y: y + ddy}})
  y += ddy - roundness
  x += roundness
  res.push({from: {x, y}, to: {x: x + dx + ddx - 21.5, y}})
  return res
}

const bottomArrow = (
  x: number,
  y: number,
  dx: number,
  dy: number,
  ddx: number
) =>
  cn(
    M(x, y),
    m(2, 0),
    h(4.5),
    c(roundness, roundness, 1),
    v(rowHeight - 2 * roundness + dy),
    c(roundness, roundness, 0),
    h(dx + ddx - 21.5)
  )

const bottomIntervals = (
  x: number,
  y: number,
  dx: number,
  dy: number,
  ddx: number
): Interval[] => {
  const res: Interval[] = []
  x += 6.5 + roundness
  y += roundness
  const ddy = rowHeight - 2 * roundness + dy
  res.push({from: {x, y}, to: {x, y: y + ddy}})
  y += ddy + roundness
  x += roundness
  res.push({from: {x, y}, to: {x: x + dx + ddx - 21.5, y}})
  return res
}

const curvedBottomArrow = (
  x: number,
  y: number,
  dx: number,
  dy: number,
  ddx: number
) =>
  cn(
    M(x, y),
    m(2, 0),
    h(4.5),
    c(roundness, roundness, 1),
    v(centerToBottom - 2 * roundness - 0.5),
    c(-roundness, roundness, 1),
    h(2 * roundness + dx - 24),
    c(-roundness, roundness, 0),
    v(dy + centerToTop - 2 * roundness + 0.5),
    c(roundness, roundness, 0),
    h(ddx + 2.5)
  )

const curvedBottomIntervals = (
  x: number,
  y: number,
  dx: number,
  dy: number,
  _ddx: number
) => {
  const res: Interval[] = []
  x += 6.5
  y += centerToBottom
  const dx1 = dx + 2 * roundness - 24
  res.push({from: {x, y}, to: {x: x + dx1, y}})
  x += dx1 - roundness
  y += roundness
  const ddy = dy + centerToTop - 2 * roundness
  res.push({from: {x, y}, to: {x, y: y + ddy}})
  return res
}

const curvedTopArrow = (
  x: number,
  y: number,
  dx: number,
  dy: number,
  ddx: number
) =>
  cn(
    M(x, y),
    m(2, 0),
    h(4.5),
    c(roundness, -roundness, 0),
    v(-centerToTop + 2 * roundness - 0.5),
    c(-roundness, -roundness, 0),
    h(2 * roundness + dx - 24),
    c(-roundness, -roundness, 1),
    v(dy - centerToBottom + 2 * roundness + 0.5),
    c(roundness, -roundness, 1),
    h(ddx + 2.5)
  )

const curvedTopIntervals = (
  x: number,
  y: number,
  dx: number,
  dy: number,
  _ddx: number
) => {
  const res: Interval[] = []
  x += 6.5
  y += -centerToTop
  const dx1 = dx + 2 * roundness - 24
  res.push({from: {x, y}, to: {x: x + dx1, y}})
  x += dx1 - roundness
  y += -roundness
  const ddy = dy - centerToTop + 2 * roundness
  res.push({from: {x, y}, to: {x, y: y + ddy}})
  return res
}

export const prepareWeekArrow = (type: ArrowType): [ArrowFn, IntervalFn] => {
  switch (type) {
    case 'top':
      return [topArrow, topIntervals]
    case 'bottom':
      return [bottomArrow, bottomIntervals]
    case 'curved-top':
      return [curvedTopArrow, curvedTopIntervals]
    case 'curved-bottom':
      return [curvedBottomArrow, curvedBottomIntervals]
  }
}
